<template>
	<div class="number-block " :class="size">
		<div class="number-block__title" v-html="title"></div>
		<div class="number-block__unit" v-html="unit"></div>
		<div class="number-block__grid">
			<div class="number-block__item" :key="key" v-for="(number, key) in numbers">
				<div class="number-block__item-label" v-html="number.title"></div>
				<div class="number-block__item-number">
					<counter :number="number.value" :options="number.options" />
					<div class="number-block__item-unit" v-html="number.unit"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Counter from '@/components/Counter.vue'

export default {
	name: 'NumberBlock',
	components: {
		Counter,
	},
	props: {
		intro: String,
		numbers: Array,
		title: String,
		unit: String,
		size: {
			type: String,
			default: ``,
		},
	},
}
</script>

<style scoped lang="scss">
.number-block {
	$block: &;
	color: var(--color--cream);
	font-family: var(--font-family--sans);

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;

	&__title {
		font-family: var(--font-family--sans);
		font-size: 1.25rem;
		font-weight: 400;
		line-height: 0.95;
		letter-spacing: 0.025rem;
		margin-bottom: 0;
		margin-top: 0;
		text-transform: uppercase;

		> span {
			font-weight: 200;
		}

	}

	&__unit {
		font-family: var(--font-family--sans);
		font-size: 16px;
		font-weight: 300;
		text-transform: uppercase;
		line-height: 19px;
		margin-top: 0;
		margin-bottom: 1rem;
		flex: 1;

		.mini & {
			margin-bottom: 0;
		}
	}

	&__grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		// grid-template-rows: 1fr 1fr;
		row-gap: 1.5rem;
		column-gap: 1.5rem;

		@include modules.media-query('tablet') {
			// display: block;
		}

		@include modules.media-query('phone') {
			display: block;
		}
	}

	&__item {
		$item: &;
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		justify-content: center;
		padding: 1.5rem;
		padding-left: 0;

		&:nth-of-type(1) {
			grid-column-start: 1;
			grid-column-end: span 2;
			border-bottom: 1px solid;
			// padding-bottom: 0;
			// padding-top: 0;

			@include modules.media-query('phone') {
				border-right: 0px solid;
			}

			#{$item}-label {
				font-size: 1.25rem;
			}

			#{$item}-number {
				color: var(--color--vibrant-mint);
				font-size: 4rem;

				.xl & {
					font-size: 6.25rem;

					@include modules.media-query('phone') {
						font-size: 4rem;
					}
				}
			}
		}

		&:nth-of-type(2) {
			border-right: 1px solid;
			padding-bottom: 0;
			padding-top: 0;
		}

		&:nth-of-type(3) {
			grid-column: 2;
			padding-bottom: 0;
			padding-top: 0;
		}

		&-label {
			font: var(--font--caption);
			font-size:0.875rem;
			font-weight: 300;
			margin-bottom: 1rem;
		}

		&-number {
			font: var(--font--h4-sans);
			font-size: 2.1875rem;
			line-height: 1;
			text-transform: uppercase;

			.xl & {
				font-size: 2.1875rem;
			}
		}
	}

	&--vert {
		column-gap: 1.5rem;
		#{$block}__item {
			&:nth-of-type(1) {
				border-bottom: 1px solid var(--color--cream);
				grid-column: span 2;
				text-align: right;
			}
			&:nth-of-type(2) {
				border-right: 1px solid var(--color--cream);
			}
		}
	}

	&--hor {

	}
}

// $color-blue: #0096D6;
// $color-yellow: #E3E431;

// .number-block {
// 	$block: &;
// 	align-items: center;
// 	display: flex;
// 	flex-direction: column;
// 	flex-wrap: nowrap;
// 	flex: 1 0 auto;

// 	// .mobile & {
// 	// 	@include gutter('margin-top', 2);
// 	// }

// 	// @include media-query-min-width('tablet') {
// 	// 	zoom: 70%;
// 	// 	flex-direction: row;
// 	// }

// 	// @include media-query-min-width('desktop') {
// 	// 	zoom: 100%;
// 	// }


// 	&__intro {
// 		// @include gutter('margin-left', 6);
// 		// color: color_('background', 'dark');
// 		// font-family: $font-family-secondary;
// 		font-size: 100px;
// 		font-weight: bold;
// 		line-height: 0.8;
// 		max-width: 500px;
// 		text-transform: uppercase;
// 		white-space: pre-wrap;

// 		.mobile & {
// 			font-size: 50px;
// 		}
// 	}

// 	&__grid {
// 		// @include gutter('padding', 1);
// 		// @include gutter('grid-row-gap');
// 		width: 100%;

// 		// @include media-query-min-width('tablet') {
// 		// 	display: grid;
// 		// 	grid-template-columns: 1fr 1fr;
// 		// 	grid-auto-rows: 1fr 1fr;
// 		// }

// 		.mobile & {
// 			grid-template-columns: 1fr 1fr;
// 			grid-auto-rows: 1fr auto;
// 		}
// 	}

// 	&__item {
// 		$item: &;
// 		// @include gutter('padding-bottom', 1);
// 		// @include gutter('padding-top', 1);
// 		align-items: flex-start;
// 		// border-bottom: 2px solid color_('primary', 'dark');
// 		display: flex;
// 		flex-direction: column;
// 		justify-content: center;

// 		// @include media-query-min-width('tablet') {
// 		// 	// @include gutter('padding', 2);
// 		// 	border-left: 2px solid color_('primary', '');
// 		// 	border-bottom: 0;
// 		// }

// 		#{$block}--yellow & {
// 			border-color: white;
// 		}

// 		#{$block}--on-teal & {
// 			// border-color: $color-blue;
// 		}

// 		.mobile & {
// 			// @include gutter('padding', 1);
// 			border-left: 0;

// 			&:first-of-type {
// 				// border-bottom: 2px solid color_('primary', 'dark');
// 			}
// 		}

// 		&:first-of-type {
// 			border-left: 0;
// 			grid-column: 1 / span 2;
// 			// border-bottom: 2px solid color_('primary', 'dark');

// 			.mobile & {
// 				grid-row: 1;
// 				grid-column: 1 / span 2;
// 			}

// 			#{$block}--on-teal & {
// 				// border-color: $color-blue;
// 			}

// 			#{$item}-label {
// 				// @include media-query-min-width('tablet') {
// 				// 	transform: translateY(25%);
// 				// }

// 				.mobile & {
// 					font-size: 20px;
// 				}

// 				#{$block}--on-teal & {
// 					// color: $color-blue;
// 				}
// 			}

// 			#{$item}-number {
// 				// @include fontSize(80px);

// 				// @include media-query-min-width('tablet') {
// 				// 	@include fontSize(80px);
// 				// }

// 				.mobile & {
// 					font-size: 100px;
// 				}

// 				#{$block}--on-blue & {
// 					// color: $color-yellow;
// 				}

// 				#{$block}--on-teal & {
// 					// color: $color-blue;
// 				}
// 			}

// 			#{$item}-unit {
// 				// @include fontSize(44px);

// 				// @include media-query-min-width('desktop') {
// 				// 	@include fontSize(80px);
// 				// }

// 				.mobile & {
// 					font-size: 30px;
// 				}
// 			}
// 		}

// 		&:nth-of-type(2) {
// 			border-left: 0;
// 			#{$block}--yellow & {
// 				// border-color: color_('text', 'xlight');
// 			}

// 			.mobile & {
// 				border-bottom: 0;
// 				border-right: 2px solid;
// 				// border-color: color_('text', 'xlight');
// 			}
// 		}

// 		&:last-of-type {
// 			// @include gutter('padding-left', 0);

// 			// @include media-query-min-width('desktop') {
// 			// 	@include gutter('padding-left');
// 			// }
// 		}

// 		&-label {
// 			// @include fontSize(16px);
// 			// color: color_('text','');
// 			font-weight: 200;
// 			margin-bottom: 1rem;

// 			#{$block}--yellow &,
// 			#{$block}--on-blue & {
// 				color: white;
// 			}

// 			.mobile & {
// 				font-size: 10px;
// 			}
// 		}

// 		&-number {
// 			// @include fontSize(42px);
// 			// color: color_('text');
// 			// font-family: $font-family-secondary;
// 			font-weight: bold;
// 			line-height: 1;
// 			letter-spacing: -0.5px;

// 			// @include media-query-min-width('tablet') {
// 			// 	@include fontSize(42px);
// 			// }

// 			#{$block}--yellow &,
// 			#{$block}--on-blue & {
// 				color: white;
// 			}

// 			.mobile & {
// 				font-size: 35px;
// 			}
// 		}

// 		&-unit {
// 			// @include fontSize(42px);
// 			// color: color_('text');
// 			display: inline-block;
// 			margin-left: 0.5rem;
// 			// font-family: $font-family-secondary;
// 			text-transform: uppercase;

// 			// @include media-query-min-width('tablet') {
// 			// 	@include fontSize(42px);
// 			// }

// 			#{$block}--yellow & {
// 				color: white;
// 			}

// 			.mobile & {
// 				font-size: 12px;
// 			}
// 		}
// 	}
// }
</style>
